<div class="toast show" [ngClass]="toast.type" role="alert" aria-live="assertive" aria-atomic="true"
    *ngFor="let toast of toastService.listToasts">
    <p class="title text-truncate">{{ toast.title }}</p>
    <p class="content">{{ toast.body }}</p>

    <button type="button" class="close" data-dismiss="toast" aria-label="Close" (click)="Close(toast)">
        <span aria-hidden="true">&times;</span>
    </button>
</div>